export const PROJECTS_LAYOUT = 'PROJECTS_LAYOUT';
export const USERS_LAYOUT = 'USERS_LAYOUT';

